export default function assert(condition, message) {
  if (!condition) {
    throw new Error("math.gl assertion ".concat(message));
  }
}
//# sourceMappingURL=assert.js.map


// WEBPACK FOOTER //
// ./~/@math.gl/core/dist/esm/lib/assert.js